import React, {
  RefObject,
  InputHTMLAttributes,
  ReactNode,
  ChangeEvent,
  ElementType,
} from "react";
import RadioButton from "../RadioButton/RadioButton";
import CheckboxButton from "../CheckboxButton/CheckboxButton";
import TextArea from "../TextArea/TextArea";
import styled from "@emotion/styled";

type Props = {
  "data-cy"?: string;
  errorMessage?: ReactNode;
  hasError: boolean;
  inputPlaceholder: string;
  inputLabel?: string;
  inputLabelStyle?: "hidden" | "above";
  onInputChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  textAreaRef?: RefObject<HTMLTextAreaElement>;
  textAreaValue?: string;
} & InputHTMLAttributes<HTMLInputElement>;

type ButtonWithTextAreaProps = {
  buttonComponent: ElementType<InputHTMLAttributes<HTMLInputElement>>;
} & Props;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

function ButtonWithTextArea({
  buttonComponent,
  checked,
  children,
  "data-cy": dataCy,
  errorMessage,
  hasError,
  inputPlaceholder,
  inputLabel,
  inputLabelStyle,
  onInputChange,
  textAreaRef,
  textAreaValue,
  ...buttonProps
}: ButtonWithTextAreaProps) {
  const ButtonComponent = buttonComponent;

  return (
    <ButtonContainer>
      <ButtonComponent checked={checked} {...buttonProps}>
        {children}
      </ButtonComponent>
      {checked && (
        <TextArea
          ref={textAreaRef}
          value={textAreaValue}
          data-cy={dataCy}
          errorMessage={errorMessage}
          hasError={hasError}
          label={inputLabel}
          labelStyle={inputLabelStyle}
          placeholder={inputPlaceholder}
          onChange={onInputChange}
        />
      )}
    </ButtonContainer>
  );
}

export function CheckboxTextArea(props: Props) {
  return <ButtonWithTextArea buttonComponent={CheckboxButton} {...props} />;
}

export function RadioTextArea(props: Props) {
  return <ButtonWithTextArea buttonComponent={RadioButton} {...props} />;
}
